import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { localizeItem } from '../content';
import {
  isKnowledgePath,
  langFromPath,
  localizedPath,
  normalizeLang,
} from '../lib/contentLocale';

export function useContentLang() {
  const { i18n } = useTranslation();
  const location = useLocation();
  if (isKnowledgePath(location.pathname)) {
    return langFromPath(location.pathname);
  }
  return normalizeLang(i18n.language);
}

export function useLocalizedItem(item) {
  const lang = useContentLang();
  return useMemo(() => localizeItem(item, lang), [item, lang]);
}

export function useLocalizedPath() {
  const lang = useContentLang();
  return (path) => localizedPath(path, lang);
}
